/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaInfoFilled: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="infoFilled" viewBox="0 0 16 16">
      <g clipPath="url(#clip0_9601_1255)">
        <path
          d="M7.98396 0.476563C6.4927 0.476211 5.03483 0.918099 3.79473 1.74634C2.55462 2.57459 1.58798 3.75198 1.01706 5.12962C0.446131 6.50727 0.296569 8.02327 0.587284 9.48592C0.877999 10.9486 1.59593 12.2922 2.65029 13.3468C3.70464 14.4014 5.04806 15.1196 6.51064 15.4107C7.97322 15.7017 9.48926 15.5525 10.867 14.9819C12.2448 14.4113 13.4224 13.445 14.251 12.2051C15.0795 10.9651 15.5217 9.50738 15.5217 8.01612C15.5217 6.01681 14.7276 4.09937 13.3141 2.68548C11.9005 1.27159 9.98327 0.477034 7.98396 0.476563ZM9.24441 12.0001C9.24441 12.3335 9.11199 12.6532 8.87627 12.8889C8.64056 13.1246 8.32087 13.257 7.98752 13.257C7.65417 13.257 7.33448 13.1246 7.09876 12.8889C6.86305 12.6532 6.73063 12.3335 6.73063 12.0001V8.06412C6.73063 7.73077 6.86305 7.41108 7.09876 7.17536C7.33448 6.93965 7.65417 6.80723 7.98752 6.80723C8.32087 6.80723 8.64056 6.93965 8.87627 7.17536C9.11199 7.41108 9.24441 7.73077 9.24441 8.06412V12.0001ZM7.98396 5.33345C7.68052 5.33345 7.3839 5.24347 7.13159 5.07489C6.87929 4.90631 6.68265 4.66669 6.56653 4.38635C6.45041 4.10601 6.42002 3.79753 6.47922 3.49992C6.53842 3.20231 6.68454 2.92894 6.8991 2.71437C7.11367 2.49981 7.38704 2.35368 7.68465 2.29449C7.98226 2.23529 8.29074 2.26567 8.57108 2.38179C8.85143 2.49791 9.09104 2.69456 9.25962 2.94686C9.4282 3.19916 9.51819 3.49579 9.51819 3.79923C9.51819 4.00071 9.4785 4.20021 9.4014 4.38635C9.3243 4.57249 9.21129 4.74162 9.06882 4.88409C8.92636 5.02655 8.75723 5.13956 8.57108 5.21667C8.38494 5.29377 8.18544 5.33345 7.98396 5.33345Z"
          fill="#0E3348"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_9601_1255">
          <rect width="16" height="16" fill="white"></rect>
        </clipPath>
      </defs>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaInfoFilled)
